import React, { useState } from "react";
import {
    Box, Button, Grid, Typography, useTheme, Chip, CircularProgress,
    Stack,
    Tooltip,
    Avatar
} from "@mui/material";
import DateChips from "../../../components/works/DateChips";
import { formatDate, timeAgo } from "../../../utils/TimeFormat";
import { OpenInNew, MovieFilter, GroupAddOutlined, Engineering, AccessTime, LocationOn } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { generateAdminURL } from "../../utills/HelperUrl";
import { getImageUrlAdminToken } from "../../utills/ImagesUtilsAdmin";

const WorkCard = ({ workContent, searchview }) => {
    const theme = useTheme();
    const navigate = useNavigate();

    console.log("WorkCard Content:", workContent);



    return (
        <React.Fragment>
            <Box

                sx={{
                    border: !searchview ? '1px solid' : 'none',
                    borderColor: 'divider',
                    backgroundColor: theme.palette.background.paper,
                    mb: 1,
                    // p: 1,
                    borderRadius: 2,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                {/* Title and Avatar Section with Background */}
                <Box
                    sx={{
                        backgroundColor: "action.hover",
                        p: 1,
                        borderRadius: 1,
                        mb: 1,
                    }}
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ width: '100%', gap: 1 }}
                    >
                        <Typography
                            variant="h6"
                            lineHeight={1.3}
                            noWrap
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                flexGrow: 1,
                                textTransform: 'capitalize',
                            }}
                        >
                            {workContent.title}
                        </Typography>
                        <Chip
                            size="small"
                            label={workContent.admin_work_status}
                            variant="text"
                            color="error"
                            onClick={() => { }}
                            clickable={false}
                            sx={{
                                fontSize: '0.75rem',
                                textTransform: 'capitalize',
                                padding: '0px 8px',
                                height: '20px',
                                flexShrink: 0,
                            }}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Avatar
                            src={getImageUrlAdminToken(workContent.user?.thumbnail_pic)}
                            alt={workContent.user?.name || workContent.creator?.name}
                            sx={{ width: 32, height: 32 , cursor: 'pointer' }}
                            //navigate to user profile "/users/userId"
                            onClick={() => {
                                navigate(`/users/${workContent.user_id}`);
                            }}
                        >
                            {(workContent.user?.name || workContent.creator?.name)?.charAt(0)?.toUpperCase()}
                        </Avatar>
                        <div>
                            <Typography variant="body2"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    flexGrow: 1,
                                    maxWidth: '200px', 
                                }}
                            >
                                {workContent.user?.name || workContent.creator?.name || 'Unknown User'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                               {timeAgo(workContent.created_at)} ago
                            </Typography>
                        </div>
                    </Box>
                </Box>



                <Grid container spacing={1} sx={{ p: 1 }}>
                    <Grid size={{ xs: 12 }}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                            <MovieFilter sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                            <Typography variant="body2" >
                                <strong>Type:</strong> {workContent.work_project_type.map(type => type.project_type_name)}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                            <Engineering sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                            <Typography variant="body2" >
                                <strong>Role:</strong> {workContent.work_roles.map((role) => role.role_name).join(', ')}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                            <AccessTime sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                            <Typography variant="body2" >
                                <strong>Duration:</strong> {workContent.duration} {workContent.duration > 1 ? 'days' : 'day'}
                            </Typography>
                        </Box>
                    </Grid>


                    {workContent.shoot_date.length > 0 && (
                    <Grid size={{ xs: 12 }}>
                        <DateChips data={workContent.shoot_date} postview={true} />
                    </Grid>
                    )}

                    <Grid size={{ xs: 12 }}>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                            <LocationOn sx={{ color: theme.palette.text.secondary, fontSize: '1.2rem' }} />
                            <Typography variant="body2" >
                                <strong>Location:</strong> {workContent.locations.map((loc) => `${loc.city}, ${loc.country}`).join(' | ')}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            {/* {!workContent.is_creator && (
                                <Typography
                                    variant="caption"
                                    gutterBottom
                                    sx={{
                                        '&::before': {
                                            content: '"Status: "',
                                            color: theme.palette.text.secondary,
                                        },
                                        color:
                                            workContent.applied_status === 'pending'
                                                ? '#FFB300'
                                                : workContent.applied_status === 'shortlisted'
                                                    ? '#2196F3'
                                                    : workContent.applied_status === 'selected'
                                                        ? '#4CAF50'
                                                        : workContent.applied_status === 'not_selected'
                                                            ? '#FF4C4C'
                                                            : theme.palette.text.secondary,
                                        fontWeight: 'medium',
                                    }}
                                >
                                    {workContent.applied_status
                                        ? workContent.applied_status.charAt(0).toUpperCase() + workContent.applied_status.slice(1)
                                        : 'N/A'}
                                </Typography>
                            )} */}

                            {workContent.is_creator && (
                                <Chip clickable={false}
                                    onClick={() => { }}
                                    size="small"
                                    icon={<GroupAddOutlined sx={{ color: theme.palette.text.secondary }} />}
                                    label={`${workContent.applied_users_count} applicants`}
                                    sx={{
                                        color: theme.palette.text.secondary,
                                        backgroundColor: 'transparent',
                                        '&:hover': { backgroundColor: 'transparent' },
                                        '& .MuiChip-icon': { color: theme.palette.text.secondary },
                                        fontWeight: 'medium',
                                    }}
                                />
                            )}


                            <Typography variant="caption" color="primary">
                                Last Date: {formatDate(workContent.end_date)}
                                <Typography
                                    variant="caption"
                                    component="span"
                                    sx={{
                                        color: workContent.status === 1 ? 'green' : workContent.status === 0 ? 'red' : 'orange',
                                        fontWeight: 'bold',
                                        ml: 0.5,
                                    }}
                                >
                                    ({workContent.status === 1 ? 'Open' : workContent.status === 0 ? 'Closed' : 'Restricted By Admin'})
                                </Typography>
                            </Typography>


                        </Box>
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                            <Button
                                fullWidth
                                variant="outlined"
                                color="primary"
                                disableElevation
                                sx={{ textTransform: 'none', }}
                                startIcon={<OpenInNew />}
                                onClick={() => navigate(generateAdminURL('jobs', workContent.work_listing_id, workContent.title))}
                            >
                                Open
                            </Button>
                        </Stack>

                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default WorkCard;